import type { FunctionComponent } from 'react';

import { defineSlotComponent, findFirstForSlot } from '../../../../../layouts/slots';
import type ProjectGroupTokenSettings from '../../../components/ProjectGroupPortalSettings';

import PortalSettings from './PortalSettings';
import ProjectsSection from './ProjectsSection/ProjectsSection';
import ReleaseGroupsFooter from './ReleaseGroupFooter';
import ReleaseGroupsDetails from './ReleaseGroupsDetails/ReleaseGroupsDetails';
import ReleaseGroupsHeader from './ReleaseGroupsHeader/ReleaseGroupsHeader';
import ReleaseGroupsPolicies from './ReleaseGroupsPolicies/ReleaseGroupsPolicies';

import styles from '../ReleaseGroupsRevamp.module.less';

type ProjectsPageContainer = FunctionComponent & {
  Header: typeof ReleaseGroupsHeader;
  Details: typeof ReleaseGroupsDetails;
  Policies: typeof ReleaseGroupsPolicies;
  Projects: typeof ProjectsSection;
  PortalTokens: typeof ProjectGroupTokenSettings;
  Footer: typeof ReleaseGroupsFooter;
};

/**
 * ProjectsPage is a container which wraps and makes the layout components
 * available to consumers of this component.
 */
const ProjectsPage: ProjectsPageContainer = ({ children }) => {
  //  Uses Slots here because the order matters for the layout
  const Header = findFirstForSlot('Header', children);
  const Details = findFirstForSlot('Details', children);
  const Policies = findFirstForSlot('Policies', children);
  const PortalTokens = findFirstForSlot('PortalTokens', children);
  const Projects = findFirstForSlot('Projects', children);
  const Footer = findFirstForSlot('Footer', children);
  return (
    <div className={styles.container}>
      {Header}
      {Details}
      {Policies}
      {PortalTokens}
      {Projects}
      {Footer}
    </div>
  );
};

ProjectsPage.Header = defineSlotComponent('Header', ReleaseGroupsHeader);
ProjectsPage.Details = defineSlotComponent('Details', ReleaseGroupsDetails);
ProjectsPage.Policies = defineSlotComponent('Policies', ReleaseGroupsPolicies);
ProjectsPage.PortalTokens = defineSlotComponent('PortalTokens', PortalSettings);
ProjectsPage.Projects = defineSlotComponent('Projects', ProjectsSection);
ProjectsPage.Footer = defineSlotComponent('Footer', ReleaseGroupsFooter);

export default ProjectsPage;
